module.exports = __webpack_public_path__ + "media/images/athletes/3540-09b1da9c21f1d4acd33edf7659fb8f67.png";